@if(this.showDetailsMission){
    <marv-drawer #drawerMissionDetails size="big" (onDidDismiss)="this.onDidDismissDrawerMission($event)">
        @if(this.missionItemSelected){
            <app-mission-details 
                [operationId]="this.missionItemSelected.operation.id" 
                [missionId]="this.missionItemSelected.missionId" 
                [activityId]="this.missionItemSelected.activityId" 
                [source]="this.missionItemSelected.source" 
                (onUpdateMission)="this.onUpdateMission($event)"
                (onDeleteMission)="this.onDeleteMission($event)"
                />
        }
    </marv-drawer>
}

<ion-grid>
    <ion-row class="ion-align-items-center ion-justify-content-between">
        <ion-col  size="auto">
            <app-type-mission-legend #typeMissionLegend [isClickable]="true" size="medium" (onClickTypeMission)="this.onClickTypeMission($event)" />
        </ion-col>
        <ion-col size="auto">
            <marv-tag [disabled]="this.tagRealizedDisabled" [isClickable]="true" size="medium" (onClickTag)="this.onClickTagRealized()">{{'REALIZED_2' | translate}} ({{this.nbMissionsRealized}})</marv-tag>
            <marv-tag [disabled]="this.tagPlannedDisabled" [isClickable]="true" size="medium" (onClickTag)="this.onClickTagPlanned()">{{'PLANNED_2' | translate}} ({{this.nbMissionsPlanned}})</marv-tag>
        </ion-col>
    </ion-row>
    <ion-row  class="ion-align-items-center ion-justify-content-center">
        <ion-col id="col_current_month" size="auto">
            <div id="current_month">
                <marv-button icon="chevron-back-outline" [rounded]="true" size="small" (click)="this.previousMonth()"/>
                <div id="current_month_infos">
                    <div id="current_month_label">
                        <ion-icon name="calendar-outline"></ion-icon>{{this.month | marvDateToString: 'MMMM YYYY'}}
                    </div>  
                    <div id="current_month_dates">
                        {{MarvDateService.GetFirstDayOfMonth(this.month) | marvDateToString}} - {{MarvDateService.GetLastDayOfMonth(this.month) | marvDateToString}}
                    </div>
                </div>                            
                <marv-button icon="chevron-forward-outline" [rounded]="true" size="small" (click)="this.nextMonth()"/>
            </div>
        </ion-col>
    </ion-row>
</ion-grid>

<div id="store_missions_list" class="ion-content-scroll-host">
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>        
    }
    @else{
        
        @if(this.missionsItemsDisplayed.length > 0){
            @for(missionItem of this.missionsItemsDisplayed; track $index){                
                <app-mission-item-history [mission]="missionItem" [isClickable]="this.showDetailsMission" (onSelectMission)="this.onSelectMission($event)"/>
            }
            <ion-infinite-scroll (ionInfinite)="this.onIonInfinite($event)" [disabled]="this.disabledInfiniteScroll">
                <ion-infinite-scroll-content></ion-infinite-scroll-content>
            </ion-infinite-scroll>
        }
        @else{ 
            <marv-message type="info">{{'MSG_NO_MISSION' | translate}}</marv-message>
        }
    }
</div>
